<div class="text-danger error-msg" *ngIf="errorMessage !== null">
  {{errorMessage}}
</div>
